import React, { useRef, useState } from "react";
import classNames from "classnames";
import useIntersectionObserver from "hooks/useIntersectionObserver";
import Loader from "components/Loader";

const ShowOnVisible = ({
  children,
  height = "300px",
  backgroundColor = "unset",
  maxHeight,
  containerClass,
}) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useIntersectionObserver({
    target: ref,
    onIntersect: ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        setIsVisible(true);
        observerElement.unobserve(ref.current);
      }
    },
  });

  return (
    <div
      ref={ref}
      className={classNames({
        showOnVisible: true,
        [containerClass]: !!containerClass,
      })}
      style={{
        minHeight: height,
        backgroundColor: backgroundColor,
        maxHeight: maxHeight || height,
        width: "100%",
      }}
    >
      {!isVisible && <Loader />}
      {isVisible && children}
    </div>
  );
};

export default ShowOnVisible;
